export default function modal() {
	document.addEventListener('DOMContentLoaded', () => {
		// @ts-ignore
		const $ = jQuery;
		let target = '';

		const closeModal = () => {
			// $(`#${target}`).removeClass('is-active');
			$(`#${target}`).fadeOut(300).removeClass('is-active');
			target = '';
			// document.body.style.overflow = 'auto';
		}

		$('.ac-modal__column').on('click', function () {
			if (target) {
				return;
			}
			// @ts-ignore
			target = $(this).data('target');
			// $(`#${target}`).addClass('is-active');
			$(`#${target}`).fadeIn(300).addClass('is-active');
			// document.body.style.overflow = 'hidden';
		});
		$('.ac-modal__close').on('click', function () {
			// @ts-ignore
			target = $(this).data('target');
			closeModal();
		});
		// @ts-ignore
		$(document).on('click',function(e) {
			if(!$(e.target).closest(`.ac-modal`).length) {
				closeModal();
			}
			if(e.target.classList.contains('ac-modal__wrapper')) {
				closeModal();
			}
		});
	});
}
